import React from 'react';
import { withRouter } from '../../components/withRouter';
import Header from '../../components/header';
import { AiOutlineArrowLeft, AiOutlinePlus, AiOutlineQrcode, AiFillContainer } from "react-icons/ai";
import { Link } from 'react-router-dom';

class AddTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <Header back={<Link to="/main"><AiOutlineArrowLeft /></Link>} pageName={'Добавление шаблона'}/>

        <button className={'btn btn_tdk_transparent'}>
          <div className={'icon'}><AiOutlinePlus style={{height: 20, width: 20}}/></div>
          <div className={'btn_content'}>
            <span>Добавить шаблон</span>
          </div>
        </button>
        <br/>
        <button className={'btn btn_tdk_transparent'}>
          <div className={'icon'}><AiOutlineQrcode style={{height: 20, width: 20}}/></div>
          <div className={'btn_content'}>
            <span>Консультация онлайн</span>
            <span className={'price'}>6 000 ₽</span>
          </div>
        </button>
        <button className={'btn btn_tdk_transparent'}>
          <div className={'icon'}><AiFillContainer style={{height: 20, width: 20}}/></div>
          <div className={'btn_content'}>
            <span>Консультация онлайн без оплаты</span>
            <span className={'price'}>6 000 ₽</span>
          </div>
        </button>
      </div>
    );
  }
}

export default withRouter(AddTemplate);